import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { convertToMoney } from '@woovi/utils';

import type { PaymentCheckoutHeading_checkout$key } from './__generated__/PaymentCheckoutHeading_checkout.graphql.ts';

import type { ReactNode } from 'react';

type PaymentCheckoutHeadingProps = {
  checkout: PaymentCheckoutHeading_checkout$key;
};

const PaymentCheckoutHeading = (
  props: PaymentCheckoutHeadingProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const checkout = useFragment<PaymentCheckoutHeading_checkout$key>(
    graphql`
      fragment PaymentCheckoutHeading_checkout on Checkout {
        value
        company {
          nameFriendly
        }
      }
    `,
    props.checkout,
  );

  const companyName = checkout.company.nameFriendly || checkout.company.name;
  const value = convertToMoney(checkout.value);

  return (
    <Typography
      sx={{
        fontSize: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightBold,
        textAlign: 'center',
      }}
    >
      {t('Pay {{value}} to {{companyName}}', { value, companyName })}
    </Typography>
  );
};

export default PaymentCheckoutHeading;
